import { languageMap } from ".."

languageMap.wasm = {
	comments: {
		line: ";;",
		block: ["(;", ";)"],
	},
}
